import { TargetsProvider } from "./TargetsContext.js";
import GroupFormation from "../GroupFormation.js";

const TargetsIndex = () => {
  return (
    <TargetsProvider>
      <GroupFormation />
    </TargetsProvider>
  );
};
export default TargetsIndex;
